import { graphql } from '@/generated/gql';

export const LOAD_QUERY_QUERY = graphql(/* GraphQL */ `
  query LoadQuery($id: uuid!) {
    queries_by_pk(id: $id) {
      id
      query
      checksum
    }
  }
`);
